import { Box, Tab, Tabs, styled } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import TabPanel from '../../../../shared/components/TabPanel'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import useTabState from '../../../../shared/hooks/useTabState'

const FeaturedTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTab-root': {
    border: '0px solid',
    borderBottom: `2px solid ${theme.palette.grey[200]}`,
    color: theme.palette.grey[400],
    height: '40px',
    minHeight: 'auto',
    marginTop: 8,
    fontWeight: 500
  },
  '& .Mui-selected': {
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    color: theme.palette.secondary.main,
    border: '0px solid'
  },
  '& .MuiTabs-indicator': {
    display: 'none'
  },
  '& .MuiTabs-root': {
    marginBottom: '16px'
  }
}))

const TestimonialGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: 40,
  marginTop: 32,
  '& p': {
    fontWeight: 500
  },
  [theme.breakpoints.down('xs')]: {
    flexWrap: 'wrap'
  }
}))

function FeaturedDetail() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const { resourceSelected } = useSelector((state: IRootState) => state.resource)

  const { currentTab, setCurrentTab, a11yProps } = useTabState()

  const ReviewBlock = (props: any) => {
    const { testimonial } = props
    const uri = `${import.meta.env.VITE_AWS_URL}/testimonials/${testimonial.file_name}`

    return (
      <TestimonialGrid sm={6} xs={12}>
        {/*<Box display="flex" flexDirection={isMobile ? 'row' : 'column'} gridGap={16}>
                    <Box>
                        <Typography variant='body2'>Nickname</Typography>
                        <Typography variant='caption'>16/12/2021</Typography>
                    </Box>
                    <Box width="max-content">
                        <Typography variant='body2'>Rango edad</Typography>
                        <Typography variant='caption'>35-45</Typography>
                    </Box>
                </Box>*/}
        <Box>
          {testimonial.filetype_id === 2 ? (
            <img src={uri} title={testimonial.title} alt={testimonial.title} width="100%" />
          ) : (
            <video src={uri} width="100%" height="100%" controls>
              Your browser does not support HTML <code>video</code>.
            </video>
          )}
        </Box>
      </TestimonialGrid>
    )
  }

  const BeforeAfterBlock = (props: any) => {
    const { testimonial } = props
    const uri = `${import.meta.env.VITE_AWS_URL}/testimonials/${testimonial.file_name}`
    return (
      <TestimonialGrid sm={6} xs={12}>
        {/*<Box display="flex" flexDirection={isMobile ? 'row' : 'column'} gridGap={16}>
                    <Box>
                        <Typography variant='body2'>Nickname</Typography>
                        <Typography variant='caption'>16/12/2021</Typography>
                    </Box>
                    <Box width="max-content">
                        <Typography variant='body2'>Rango edad</Typography>
                        <Typography variant='caption'>35-45</Typography>
                    </Box>
                </Box>*/}
        <Box>
          {testimonial.filetype_id === 2 ? (
            <img src={uri} title={testimonial.title} alt={testimonial.title} width="100%" />
          ) : (
            <video src={uri} width="100%" height="100%" controls>
              Your browser does not support HTML <code>video</code>.
            </video>
          )}
        </Box>
      </TestimonialGrid>
    )
  }

  return (
    <>
      <FeaturedTabs
        value={currentTab}
        indicatorColor="secondary"
        textColor="primary"
        scrollButtons={true}
        variant={isMobile ? 'scrollable' : 'standard'}
        centered
        onChange={(_, newValue) => setCurrentTab(newValue)}
        aria-label="disabled tabs example"
      >
        <Tab label={t('reviews')} {...a11yProps(0)} />
        <Tab label={t('before-and-after')} {...a11yProps(1)} />
        {/*<Tab label={t("related-courses")}   {...a11yProps(2)} />
                <Tab label={t("related-docs")}   {...a11yProps(3)} />*/}
      </FeaturedTabs>

      <TabPanel value={currentTab} index={0}>
        <Grid container spacing={2}>
          {/* Mapeo de los testimonios relacionados */}
          {resourceSelected.testimonials
            .filter((testimonial: any) => testimonial.type === 0)
            .map((testimonial: any) => (
              <ReviewBlock key={testimonial.id} testimonial={testimonial} />
            ))}
        </Grid>
      </TabPanel>
      <TabPanel value={currentTab} index={1}>
        <Grid container spacing={4}>
          {/* Mapeo de los fotos de antes y despúes relacionados */}
          {resourceSelected.testimonials
            .filter((testimonial: any) => testimonial.type === 1)
            .map((testimonial: any) => (
              <BeforeAfterBlock key={testimonial.id} testimonial={testimonial} />
            ))}
        </Grid>
      </TabPanel>
      <TabPanel value={currentTab} index={2}>
        <Grid container spacing={2} direction="row" alignItems="stretch">
          {/* Mapeo de cursos relacionados
                    <Grid item xs={6} sm={4}>
                        <CourseBlock />
                    </Grid> */}
        </Grid>
      </TabPanel>
      <TabPanel value={currentTab} index={3}>
        <Grid container spacing={3}>
          {/* Mapeo de documentos relacionados
                    <MediaFileBlock/>  */}
        </Grid>
      </TabPanel>
    </>
  )
}

export default FeaturedDetail
